import { COOKIE } from "@/constants/Cookie";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { z } from "zod";

export const CookiesSchema = z.object({
  created_at: z.string().nullable(),
  token: z.string().optional(),
  status: z.string().nullable().optional(),
});

export type UserCookies = z.infer<typeof CookiesSchema>;

type CookieServer = {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  req: any;
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  res: any;
};

type SetServerCookies = CookieServer & {
  data: {
    token?: string;
    status?: string | null;
    refreshToken?: string;
  };
};

export function getClientCookies() {
  const rawCookies = getCookie(COOKIE.NAME);
  const parsed = CookiesSchema.safeParse(JSON.parse(rawCookies || "{}"));

  if (!parsed.success) return;

  return parsed.data;
}

export function getServerCookies({ req, res }: CookieServer) {
  const rawCookies = getCookie(COOKIE.NAME, { req, res })?.valueOf();

  const parsed = CookiesSchema.safeParse(JSON.parse(rawCookies || "{}"));

  if (!parsed.success) {
    console.error("Failed to parse cookies:", parsed.error);
    return;
  }

  return parsed.data;
}

export async function setServerCookies({ data, req, res }: SetServerCookies) {
  const now = new Date().toISOString();
  const { refreshToken, ...sessionData } = data;

  setCookie(COOKIE.NAME, JSON.stringify({ ...sessionData, created_at: now }), {
    req,
    res,
    maxAge: COOKIE.MAX_AGE,
    secure: true,
    sameSite: "none",
  });

  if (refreshToken) {
    setCookie(COOKIE.REFRESH_NAME, refreshToken, {
      req,
      res,
      maxAge: COOKIE.MAX_AGE,
      path: COOKIE.REFRESH_PATH,
      httpOnly: true,
      secure: true,
      sameSite: "strict",
    });
  }
}

export async function removeServerCookies() {
  deleteCookie(COOKIE.NAME);
}

// O cookie do refresh token é httpOnly: só pode ser lido/removido no servidor (rotas BFF em /api).
export function getServerRefreshToken({ req, res }: CookieServer) {
  const value = getCookie(COOKIE.REFRESH_NAME, { req, res });
  return typeof value === "string" && value ? value : undefined;
}

export function removeServerRefreshToken({ req, res }: CookieServer) {
  deleteCookie(COOKIE.REFRESH_NAME, { req, res, path: COOKIE.REFRESH_PATH });
}
